var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_934",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.00012C5.92508 1.00012 1 5.9252 1 12.0001C1 18.075 5.92508 23.0001 12 23.0001C18.0749 23.0001 23 18.075 23 12.0001C23 5.9252 18.0749 1.00012 12 1.00012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16099 18.163C12.7734 18.163 18.1342 12.8022 18.1342 6.18978C18.1357 4.93851 17.9409 3.69476 17.5567 2.50392C15.8718 1.51591 13.9532 0.996655 12 1.00002C5.92509 1.00002 1.00001 5.92509 1.00001 12C0.997032 13.9717 1.52673 15.9076 2.53314 17.6031C3.70641 17.9753 4.9301 18.1642 6.16099 18.163Z",
    fill: "white",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9954 19.4615C11.6419 19.4615 11.2963 19.3567 11.0023 19.1603C10.7083 18.9639 10.4792 18.6848 10.3438 18.3582C10.2084 18.0316 10.1729 17.6722 10.2417 17.3254C10.3106 16.9786 10.4807 16.6601 10.7306 16.4099C10.9805 16.1598 11.2989 15.9894 11.6456 15.9202C11.9923 15.8511 12.3517 15.8862 12.6785 16.0213C13.0052 16.1563 13.2846 16.3852 13.4812 16.679C13.6779 16.9728 13.783 17.3183 13.7834 17.6719C13.7836 17.9068 13.7375 18.1395 13.6478 18.3566C13.558 18.5737 13.4264 18.771 13.2603 18.9372C13.0943 19.1035 12.8971 19.2353 12.6801 19.3253C12.463 19.4152 12.2304 19.4615 11.9954 19.4615ZM13.7284 13.3041C13.6983 13.5804 13.5735 13.8377 13.3752 14.0324C13.1742 14.2285 12.9128 14.3507 12.6335 14.3792H12.6254C12.4502 14.3992 12.274 14.4093 12.0977 14.4093C11.8864 14.4103 11.6751 14.4003 11.4648 14.3792H11.4562C11.177 14.3506 10.9158 14.2284 10.715 14.0324C10.5167 13.8377 10.3919 13.5804 10.3618 13.3041C10.3188 12.9006 10.2973 10.0986 10.2973 9.4743C10.2973 8.84997 10.3192 6.04067 10.3618 5.6372C10.3914 5.36016 10.5162 5.10198 10.715 4.90673C10.916 4.711 11.1771 4.58882 11.4562 4.55997H11.4648C11.6751 4.53896 11.8865 4.5325 12.0977 4.54064C12.2737 4.53249 12.45 4.53896 12.6249 4.55997H12.6335C12.9132 4.58967 13.1746 4.71309 13.3752 4.91017C13.5739 5.10541 13.6988 5.36359 13.7284 5.64063C13.7713 6.04411 13.7928 8.85384 13.7928 9.47774C13.7928 10.1016 13.7709 12.9023 13.7284 13.3041Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/ExclamationCircle.9af8260edc9529f55455fd5631e92588.svg";
export { ForwardRef as ReactComponent };